<template>
  <SelectSimple
    v-if="countries.length > 0"
    :ariaLabel="insertString('Global', 'Footer', 'ChooseShippingCountry')"
    :inverted="inverted"
    :smallArrow="small"
    :small="small"
    :disabled="disabled"
    v-model="selectedValue"
    :placeholder="insertString('Global', 'Footer', 'ChooseShippingCountry')"
    :options="countries"
    optionLabel="Label"
    optionValue="Value"
  >
    <template v-if="flag" v-slot:prefix>
      <div class="d-flex align-items-center m-r-3">
        <CountryFlag :country="selectedValue" size="small" />
      </div>
    </template>
  </SelectSimple>
</template>
<script>

import stringHelper from '@/Scripts/lib/helper/stringHelper.js';
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
const SelectSimple = () => import(/* webpackChunkName: "SelectSimple" */ '@/Scripts/components/shared/SelectSimple/SelectSimple.vue');
const CountryFlag = () => import(/* webpackChunkName: "countryflag" */ 'vue-country-flag');

export default {
  mixins: [siteInfo],
  props: {
    inverted: {
      type: Boolean,
      default: true
    },
    flag: Boolean,
    small: Boolean,
    disabled: Boolean

  },
  components: {
    SelectSimple,
    CountryFlag
  },
  computed: {
    selectedValue: {
      // getter
      get: function () {
        return document.body.getAttribute('data-country-code');
      },
      // setter
      set: function (newValue) {
        this.changeSelected(newValue);
      }
    }
  },
  methods: {
    changeSelected: function (value) {
      location.href = stringHelper.updateUrlParameter(
        location.href,
        'changeCountry',
        value
      );
    }
  }
};
</script>
